import {
    createStoreFilter,
    StoreFullExtractor,
} from 'src/modules/store/extractors';
import { IStore } from 'src/interfaces/store';

const extractor = new StoreFullExtractor();

/**
 * Get all stores by make
 * @param stores - The stores to get the stores by make
 * @param makeId - The make id to get the stores by make
 * @returns An array of stores
 */

export const getStoresByMake = (stores: IStore[], makeId: string): IStore[] =>
    createStoreFilter(extractor)(stores, makeId);
